import React from "react";
import { MusicScale } from "../../../wasm/pkg/wasm";
import { AppContextType } from "../../AppContext";
import { printScaleRootLetter } from "../../models/wasm.model";

interface Props {
  scale: MusicScale;
}
interface State {}

export default class MusicScaleName extends React.Component<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;

  render() {
    const { scale } = this.props;
    const { isPreferMajor } = this.context.keySelectionOptions;
    const noteName = printScaleRootLetter(scale, isPreferMajor);

    return <div className="music-scale-name">{noteName}</div>;
  }
}

MusicScaleName.contextType = AppContextType;
